import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { privatePensionSchema } from '@flows/configs/de/privatePension/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface PrivatePensionStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  environment: string
  platform: 'web' | 'native'
}

export const incomeSchema = z.object({
  products: z.object({
    mga_private_pension_de: z.object({
      configuration_parameters: privatePensionSchema.pick({
        income: true,
      }),
    }),
  }),
})

export const employmentSchema = z.object({
  products: z.object({
    mga_private_pension_de: z.object({
      configuration_parameters: privatePensionSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const investMoneySchema = z.object({
  products: z.object({
    mga_private_pension_de: z.object({
      configuration_parameters: privatePensionSchema.pick({
        invest_money: true,
      }),
    }),
  }),
})

export const successSchema = z.object({})
